import React from 'react';
import classNames from 'classnames';
import LargeArrow from 'images/icons/careers/large-arrow.svg';
import { MEDIA_QUERY_MOBILE_DOWN } from 'utils/constants/breakpoints';
import * as styles from './styles/styles.module.scss';

type ImageSource = { src: string; mobileSrc: string };

type HeroImageProps = {
  backgroundImage: { jpg: ImageSource; webp: ImageSource; avif: ImageSource; alt: string };
  headerText: string;
  headerSubText: string;
  onArrowClick: () => void;
  imgClassName?: string;
};

const HeroImage = ({ backgroundImage, headerText, headerSubText, onArrowClick, imgClassName }: HeroImageProps): JSX.Element => {
  const { jpg, avif, webp } = backgroundImage;
  return (
    <div className={styles.container}>
      <picture>
        <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={avif.mobileSrc} type="image/avif" />
        <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={webp.mobileSrc} type="image/webp" />
        <source media={MEDIA_QUERY_MOBILE_DOWN} srcSet={jpg.mobileSrc} type="image/jpg" />
        <source srcSet={avif.src} type="image/avif" />
        <source srcSet={webp.src} type="image/webp" />
        <img alt={backgroundImage.alt} src={jpg.src} className={classNames(styles.hero, imgClassName)} />
      </picture>
      <div className={styles.innerContainer}>
        <h1 className={styles.headerText}>{headerText}</h1>
        <span className={styles.headerSubtext}>{headerSubText}</span>
      </div>
      <button type="button" className={styles.largeArrow} onClick={onArrowClick}>
        <img src={LargeArrow} alt="" />
      </button>
    </div>
  );
};

export { HeroImage as default, HeroImageProps };
